import { datadogRum } from '@datadog/browser-rum';

const isDatadogEnabled = () => {
  return (
    process.env.REACT_APP_ENVIRONMENT === 'prod' &&
    Boolean(process.env.REACT_APP_DATADOG_ID) &&
    Boolean(process.env.REACT_APP_DATADOG_TOKEN)
  );
};

export const initLogger = () => {
  if (!isDatadogEnabled()) {
    // En dev/test no inicializamos Datadog ni ensuciamos consola.
    return;
  }

  const applicationId = process.env.REACT_APP_DATADOG_ID as string;
  const clientToken = process.env.REACT_APP_DATADOG_TOKEN as string;

  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.eu',
    service: 'cdsc-web-app',
    env: process.env.REACT_APP_ENVIRONMENT,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    silentMultipleInit: true,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend: (event) => {
      // remove id_token from view url
      event.view.url = event.view.url.replace(
        /id_token=[^&]*/,
        'id_token=REDACTED'
      );
      // remove access_token from view url
      event.view.url = event.view.url.replace(
        /access_token=[^&]*/,
        'access_token=REDACTED'
      );
    }
  });
  datadogRum.startSessionReplayRecording();
};

export const setUserToLogger = async (name: string) => {
  if (!isDatadogEnabled()) return;

  datadogRum.setUser({
    name
  });
};

export const setUserRoleToLogger = (role: string) => {
  if (!isDatadogEnabled()) return;

  datadogRum.addRumGlobalContext('userData', {
    role
  });
};
